import React, { Suspense, useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import i18n from "./stores/i18n";
import * as mqtt from "mqtt/dist/mqtt.min";

import Header from "./components/header";
import Footer from "./components/footer";
import About from "./pages/about";
import Main from "./pages/main";
import Login from "./pages/login";
import SearchId from "./pages/search_id";
import SearchPassword from "./pages/search_password";
import MemberJoin from "./pages/join";
import MyPage from "./pages/mypage";
import ModifyMember from "./pages/modify_member";
import ModifyDevice from "./pages/modify_device";
import ModifyGuardian from "./pages/modify_guardian";
import Policy from "./pages/policy";
import Service from "./pages/service";
import Statistics from "./pages/statistics";
import Emergency from "./pages/emergency";
import EmergencyDetail from "./pages/emergency_detail";

import useClientStore from "./stores/client";

function App() {
    const { client, setClient, onMessage } = useClientStore();
    const onMessageRef = useRef(onMessage);

    useEffect(() => {}, []);

    useEffect(() => {
        onMessageRef.current = onMessage;
    }, [onMessage]);

    useEffect(() => {
        const url = process.env.REACT_APP_MQTT_URL;

        const client = mqtt.connect(url);

        client.on("connect", () => {
            setClient(client);
        });
        client.on("close", function () {
            setClient(null);
        });
        client.on("reconnect", () => {});

        client.on("message", (topic, message) => {
            if (onMessageRef.current[topic]) {
                onMessageRef.current[topic](topic, message);
            }
        });

        setClient(client);

        return () => {
            if (client) {
                client.end(() => {
                    //console.log("disconnect");
                });
            }
        };
    }, []);

    return (
        <>
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/statistics" element={<Statistics />} />
                    <Route path="/emergency" element={<Emergency />} />
                    <Route path="/emergency/detail" element={<EmergencyDetail />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/login/id" element={<SearchId />} />
                    <Route path="/login/password" element={<SearchPassword />} />
                    <Route path="/join" element={<MemberJoin />} />
                    <Route path="/mypage" element={<MyPage />} />
                    <Route path="/modify/member" element={<ModifyMember />} />
                    <Route path="/modify/device" element={<ModifyDevice />} />
                    <Route path="/modify/guardian" element={<ModifyGuardian />} />
                    <Route path="/policy" element={<Policy />} />
                    <Route path="/service" element={<Service />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </>
    );
}

export default App;
